import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

export type PetitionAngleData = {
	readonly id: string;
	readonly recommendation: string;
	readonly why: string;
	readonly ask: string;
	readonly description: string;
};

/**
 * The source post's stats, snapshotted when it was scraped. Each is `null` when missing, which
 * older drafts always are.
 */
export type PetitionAnglesPostStats = {
	readonly followerCount: number | null;
	readonly viewCount: number | null;
	readonly commentCount: number | null;
	/** ISO 8601 timestamp of when the post was published. */
	readonly postedAt: string | null;
};

export type PetitionAnglesPageData = {
	readonly token: string;
	readonly username: string | null;
	readonly name: string | null;
	readonly platform: string | null;
	readonly avatarUrl: string | null;
	readonly videoCoverUrl: string | null;
	readonly caption: string | null;
	readonly drafts: readonly PetitionAngleData[];
	readonly sourceLocation: string | null;
	/** The source post's URL, used to embed it (TikTok) and link back to it. */
	readonly sourceUrl: string | null;
	readonly postStats: PetitionAnglesPostStats;
	readonly imagePrewarmEnabled: boolean;
	readonly videoConsentCheckboxEnabled: boolean;
};

export type SocialStarterPetitionDecisionMakerData = {
	readonly id: string;
	readonly displayName: string;
	readonly title: string | null;
	readonly summary: string | null;
	readonly photoUrl: string | null;
};

export type PetitionAnglesPageDataWithDecisionMaker = PetitionAnglesPageData & {
	readonly decisionMaker: SocialStarterPetitionDecisionMakerData;
};

export type PetitionAnglesPageDataErrorCode = 'social_starter_not_found';
export class PetitionAnglesPageDataError extends PageDataError<PetitionAnglesPageDataErrorCode> {}
setClassName(PetitionAnglesPageDataError, 'PetitionAnglesPageDataError');
